import React from "react";
import AnchorLink from 'react-anchor-link-smooth-scroll'
import hImg from '@images/1.webp'
import { LanguageContext } from '../../index';
const Hero = () => {
    const { language } = React.useContext(LanguageContext);

    const content = {
        pl: {
            title: "Podłogi klasy premium",
            subtitle: "Dotyk luksusu każdego dnia",
        },
        en: {
            title: "Premium Class Floors",
            subtitle: "Touch of Luxury Every Day",
        },
    };

    const { title, subtitle } = content[language] || content.en;

    return (
        <section className="hero-section text-center mt-110 rmt-70" style={{ backgroundImage: `url(${hImg})` }}>
            <div className="container">
                <div className="hero-content">
                    <h1 className="text-bold text-white">{title}</h1>
                    <h1 className="text-lighter">{subtitle}</h1>
                    <AnchorLink href='#about' className="scroll-down scroll">
                        <div className="scroll-box"></div>
                    </AnchorLink>
                </div>
            </div>
        </section>
    );
};



export default Hero;